import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import apiClient from "@/lib/api";

const SUPPORTED_LANGS = ["fr", "en", "es", "zh", "ru", "pt"];

function getSessionId() {
  let sid = sessionStorage.getItem("fastority_sid");
  if (!sid) {
    sid = crypto.randomUUID();
    sessionStorage.setItem("fastority_sid", sid);
  }
  return sid;
}

export const Analytics = () => {
  const location = useLocation();
  const lastTracked = useRef(null);

  useEffect(() => {
    if (typeof window.gtag === "function") {
      window.gtag("event", "page_view", {
        page_path: location.pathname + location.search,
        page_location: window.location.href,
        page_title: document.title,
      });
    }

    const key = location.pathname + location.search;
    if (lastTracked.current === key) return;
    lastTracked.current = key;

    const firstSegment = location.pathname.split("/")[1];
    const lang = SUPPORTED_LANGS.includes(firstSegment) ? firstSegment : "fr";
    apiClient
      .post("/visits/track", {
        session_id: getSessionId(),
        path: location.pathname,
        lang,
      })
      .catch(() => {});
  }, [location.pathname, location.search]);

  return null;
};
